/**
 * Function to convert string to title case
 * where by the first letter is capitalised and the rest is lower case
 * @param str any case string
 * @returns capitalised first letter followed by lower case letters.
 */
export const toTitleCase = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
